import styled, { useTheme } from 'styled-components';
import { SortEnum } from 'src/constants';
import { SortIcon } from 'src/assets';

type SortIconsProps = {
  activeSort?: SortEnum;
};
const SortIcons: React.FC<SortIconsProps> = ({ activeSort }) => {
  const { colors } = useTheme();

  let topColor = colors.borders.default;
  let bottomColor = colors.borders.default;
  if (activeSort === SortEnum.ASC) {
    topColor = colors.text.secondary;
  } else if (activeSort === SortEnum.DESC) {
    bottomColor = colors.text.secondary;
  }

  return (
    <Container>
      <TopIcon>
        <SortIcon color={topColor} />
      </TopIcon>
      <SortIcon color={bottomColor} />
    </Container>
  );
};
export default SortIcons;

export const TopIcon = styled.div`
  display: flex;
  transform: rotate(180deg) translateY(-2px);
  margin-bottom: 0.2rem;
`;
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
